import { useQuery } from '@apollo/client'

import {
  BrandShippingInfoDocument,
  CountriesForAddressModalDocument,
  RetailerLocationsDocument,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
  query CountriesForAddressModal {
    geographies(types: ["COUNTRY"]) {
      edges {
        node {
          id
          name
          taxLabel
        }
      }
    }
  }
`

export const useCountries = () => {
  const { data, loading } = useQuery(CountriesForAddressModalDocument, {
    client: atlasClient,
  })

  return {
    geographies: data?.geographies,
    loadingGeographies: loading,
  }
}

atlas`#graphql
  query BrandShippingInfo($filter: BrandsFilter, $connectedAccountIds: [ID!]) {
    brands(filter: $filter) {
      edges {
        node {
          id
          connectedAccounts(filter: {connectedAccountIds: $connectedAccountIds}) {
            edges {
              billingAddresses {
                id
                phoneNumber
                code
                address {
                  line1
                  line2
                  city
                  state
                  zip
                  country
                  name
                  companyName
                }
              }
              shippingAddresses {
                id
                email
                phoneNumber
                code
                address {
                  line1
                  line2
                  city
                  state
                  zip
                  country
                  name
                  companyName
                }
              }
              shippingMethods {
                shippingMethod {
                  id
                  name
                  code
                }
              }
              paymentMethods {
                paymentMethod {
                  id
                  name
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`

export const useBrandShippingBillingInfo = (
  brandId?: string,
  retailerId?: string,
) => {
  const { data, loading } = useQuery(BrandShippingInfoDocument, {
    client: atlasClient,
    variables: {
      filter: {
        brandIds: [brandId!],
      },
      ...(retailerId && { connectedAccountIds: [retailerId] }),
    },
    skip: !brandId,
  })

  // we were getting a runtime error when not using optional chaining
  // we should check it out later and make sure our typing is accurate
  // enough to catch that kind of errors
  return { brand: data?.brands?.edges?.[0]?.node, loadingBrandInfo: loading }
}

atlas`#graphql
  query RetailerLocations($retailerId: ID!) {
    retailer(id: $retailerId) {
      id
    	publicRetailerProfile {
        id
        email
      }
      locations {
        id
        address1
        address2
        city
        state
        zip
        country
        name
        type
        phone
        isPrimaryLocation
      }
    }
  }
`

export const useLiteRetailerAddresses = (retailerId: string = '') => {
  const { data, loading } = useQuery(RetailerLocationsDocument, {
    client: atlasClient,
    variables: {
      retailerId,
    },
    skip: !retailerId,
  })

  return { data, loading }
}
